import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { StoreBadges } from '@/components/StoreBadges';

export const CtaBanner = () => {
  const { t } = useTranslation();
  return (
    <section className="px-6 py-24 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, scale: 0.96, y: 32 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="relative overflow-hidden rounded-3xl border border-brand/30 bg-gradient-to-br from-surface to-black px-8 py-16 text-center sm:px-16">
            <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-brand/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-brand/10 blur-3xl" />
            <h2 className="relative font-display text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
              {t('ctaBanner.title1')} <span className="text-brand glow-text">{t('ctaBanner.title2')}</span>
            </h2>
            <p className="relative mx-auto mt-4 max-w-xl text-base text-white/60">
              {t('ctaBanner.subtitle')}
            </p>
            <div className="relative mt-8 flex flex-col items-center gap-5">
              <Link to="/pricing" data-testid="cta-banner-trial" className="btn-primary cta-pulse text-base">{t('common.start7DayTrial')}</Link>
              <StoreBadges align="center" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
